interface GetCurrencySelectOptionsParams {
  baseCurrency: string
  counterCurrency: string
  supportedCurrenciesPairsAllCombinations: string[]
  isSettingsLoading?: boolean
}

const getSupportedCurrencies = (
  targetCurrency: string,
  oppositeCurrency: string,
  changedCurrency: 'base' | 'counter',
  supportedCurrenciesPairsAllCombinations: string[],
): string[] => {
  const normalizedCurrency = targetCurrency.toUpperCase()
  const currencyToExclude = oppositeCurrency?.toUpperCase()
  const isBaseCurrencyChanged = changedCurrency === 'base'

  const matchingPairs = supportedCurrenciesPairsAllCombinations.filter((pair) => {
    return isBaseCurrencyChanged ? pair.endsWith(normalizedCurrency) : pair.startsWith(normalizedCurrency)
  })

  const mappedCurrencies = matchingPairs.map((pair) => {
    return isBaseCurrencyChanged ? pair.slice(0, 3) : pair.slice(3)
  })

  const filteredCurrencies = mappedCurrencies.filter((currency) => currency !== currencyToExclude)
  const uniqueCurrencies = Array.from(new Set(filteredCurrencies))

  if (!uniqueCurrencies.includes(normalizedCurrency)) {
    uniqueCurrencies.unshift(normalizedCurrency)
  }

  return uniqueCurrencies
}

export const getCurrencySelectOptions = ({
  baseCurrency,
  counterCurrency,
  supportedCurrenciesPairsAllCombinations,
  isSettingsLoading = false,
}: GetCurrencySelectOptionsParams): { baseCurrencyOptions: string[]; counterCurrencyOptions: string[] } => {
  if (!supportedCurrenciesPairsAllCombinations.length) {
    if (!isSettingsLoading) {
      console.warn('No supported currency pairs available. Cannot determine options for selects.')
    }
    return {
      baseCurrencyOptions: [],
      counterCurrencyOptions: [],
    }
  }

  const hasBaseCurrency = Boolean(baseCurrency)
  const hasCounterCurrency = Boolean(counterCurrency)

  if (!hasBaseCurrency) {
    console.warn('No base currency selected. Cannot determine options for counter currency.')
  }

  if (!hasCounterCurrency) {
    console.warn('No counter currency selected. Cannot determine options for base currency.')
  }

  const counterCurrencyOptions = hasBaseCurrency
    ? getSupportedCurrencies(baseCurrency, counterCurrency, 'base', supportedCurrenciesPairsAllCombinations)
    : []

  const baseCurrencyOptions = hasCounterCurrency
    ? getSupportedCurrencies(counterCurrency, baseCurrency, 'counter', supportedCurrenciesPairsAllCombinations)
    : []

  return { baseCurrencyOptions, counterCurrencyOptions }
}
